import { render } from "./DesktopSearch.vue?vue&type=template&id=c9fc5d20&scoped=true"
import script from "./DesktopSearch.vue?vue&type=script&lang=js"
export * from "./DesktopSearch.vue?vue&type=script&lang=js"

import "./DesktopSearch.vue?vue&type=style&index=0&id=c9fc5d20&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9fc5d20"]])

export default __exports__